import React from "react";

const STATUS_COLORS = {
  all:               "bg-purple-400 hover:bg-purple-500",
  pending:           "bg-yellow-400 hover:bg-yellow-500",
  accept:            "bg-cyan-500 hover:bg-cyan-600",
  "delivery pickup": "bg-blue-500 hover:bg-blue-600",
  "out for delivery":"bg-orange-400 hover:bg-orange-500",
  completed:         "bg-green-500 hover:bg-green-600",
};

const OrderStatusBlocks = ({
  displayStatuses,
  handleStatusClick,
  selectedSort,
  getCountByStatus,
}) => (
  <div className="hidden md:flex flex-wrap gap-2.5 mb-6">
    {displayStatuses.map((status) => {
      const isActive = selectedSort === status || (status === "all" && !selectedSort);
      return (
        <div
          key={status}
          onClick={() => handleStatusClick(status)}
          className={`h-20 w-36 flex flex-col items-center justify-center text-center text-white text-sm
            font-semibold rounded-xl cursor-pointer whitespace-nowrap flex-none select-none
            transition-all duration-200 shadow-sm
            ${isActive
              ? "bg-amber-400 scale-105 shadow-md text-gray-800"
              : STATUS_COLORS[status] || "bg-purple-400 hover:bg-purple-500"
            }`}
        >
          <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
          <span className="text-xs mt-0.5 opacity-90">({getCountByStatus(status)})</span>
        </div>
      );
    })}
  </div>
);

export default OrderStatusBlocks;
